<template>
  <div class="second-customer-modal">
    <div class="row mb-2">
      <div class="col d-flex justify-content-between align-items-center">
        <h4 class="">{{ customer.first_name }} {{ customer.last_name }}</h4>
        <button @click="$emit('close')" class="btn btn-close p-0"><span class="mod-icon-close opacity-50" /></button>
      </div>
    </div>
    <div class="plan-includes">
      <div class="promo-features mt-3">
        <div class="promo-feature">
          <span class="mod-icon-edit mod-icon-phone" aria-hidden="true" />
          {{ customer.phone ? phoneMask.maskedPhone(customer.phone) : 'No phone added' }}
        </div>
        <div class="promo-feature">
          <span class="mod-icon-edit mod-icon-email" aria-hidden="true" />
          {{ customer.email }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneMask from '../../../classes/PhoneMask';

export default {
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      phoneMask: new PhoneMask(),
    };
  },
};
</script>

<style scoped lang="scss">
.second-customer-modal {
  position: absolute;
  width: 350px;
  z-index: 99;
  background-color: #ffffff;
  top: 30px;
  float: right;
  border: 1px solid #d2d2d4;
  border-radius: 5px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/modals/SecondCustomerInfo.vue